import React from "react"
import badge from "badges/risk-management.svg"
import { BadgeImage } from "backpack/badges/styled"

const RiskManagement = props => <BadgeImage src={badge} {...props} />

export default RiskManagement
